export const INSUFFICIENT_AMOUNT_ERROR_CODE = 'insufficient_amount'
export const FEES_AMOUNT = 'fees_greater_than_amount'